// NOTE THAT ANY CHANGES TO THE CHECKPOINT DEFINITION OVER HERE

// MUST BE REFLECTED IN COPYCHECKPOINT AND NEWCHECKPOINT FUNCTION IN USECHECKLISTEDITOR.JS
const initCheckpoint: Checkpoint = {
	ChecklistID: 0,
	CheckpointID: 0,
	Name: 'Template Checkpoint',
	Description: '',
	ResponseType: 'Status',
	Sort: null,
	Status: [
		{
			StatusID: -1,
			StatusNumber: 1,
			Name: 'Clear',
			isEnabled: true,
			isCommentRequired: false,
		},
		{
			StatusID: -1,
			StatusNumber: 2,
			Name: 'Warning',
			isEnabled: true,
			isCommentRequired: true,
		},
		{
			StatusID: -1,
			StatusNumber: 3,
			Name: 'Emergency',
			isEnabled: true,
			isCommentRequired: true,
		},
	],
	Dropdowns: [
		// {
		// 	DropdownID: -1,
		// 	Name: '',
		// 	DropdownType: 'dropdownResponseOption',
		// },
	],
	isSelected: false,
	CheckpointDateTime: null, 
};
export default initCheckpoint;
